import { render, staticRenderFns } from "./Saldo.html?vue&type=template&id=688d5cd2&scoped=true&"
import script from "./Saldo.js?vue&type=script&lang=js&"
export * from "./Saldo.js?vue&type=script&lang=js&"
import style0 from "./Saldo.scss?vue&type=style&index=0&id=688d5cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688d5cd2",
  null
  
)

export default component.exports